import React from 'react';
import { X, MessageSquare, ThumbsUp, PlusCircle, Bell } from 'lucide-react';

interface SubscribeModalProps {
  showSubscribeModal: boolean;
  setShowSubscribeModal: (show: boolean) => void;
  email: string;
  setEmail: (email: string) => void;
  session: any;
  setShowLoginModal: (show: boolean) => void;
}

const SubscribeModal: React.FC<SubscribeModalProps> = ({
  showSubscribeModal,
  setShowSubscribeModal,
  email,
  setEmail,
  session,
  setShowLoginModal
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex justify-between items-center border-b border-gray-200 p-6">
          <h2 className="text-xl font-bold text-gray-900">Subscribe to Updates</h2>
          <button 
            className="text-gray-400 hover:text-gray-500"
            onClick={() => setShowSubscribeModal(false)}
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        
        <div className="p-6">
          <p className="text-gray-600 mb-6">
            Stay informed about new discussions, responses to your posts, and other community updates. 
            Customize your notification preferences below.
          </p>
          
          <div className="space-y-4 mb-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <MessageSquare className="h-5 w-5 text-indigo-600 mr-3" />
                <span className="text-gray-800">New responses to my discussions</span>
              </div>
              <input 
                type="checkbox" 
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                defaultChecked
              />
            </div>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <ThumbsUp className="h-5 w-5 text-indigo-600 mr-3" />
                <span className="text-gray-800">Likes on my posts</span>
              </div>
              <input 
                type="checkbox" 
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                defaultChecked
              />
            </div>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <PlusCircle className="h-5 w-5 text-indigo-600 mr-3" />
                <span className="text-gray-800">New discussions in categories I follow</span>
              </div>
              <input 
                type="checkbox" 
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                defaultChecked
              />
            </div>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <Bell className="h-5 w-5 text-indigo-600 mr-3" />
                <span className="text-gray-800">Community announcements</span>
              </div>
              <input 
                type="checkbox" 
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                defaultChecked
              />
            </div>
          </div>
          
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="email">
              Email Address
            </label>
            <input 
              type="email" 
              id="email" 
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              placeholder="your.email@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          
          <div className="flex justify-end space-x-4">
            <button 
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
              onClick={() => setShowSubscribeModal(false)}
            >
              Cancel
            </button>
            <button 
              className="px-6 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors"
              onClick={() => {
                setShowSubscribeModal(false);
                if (!session) setShowLoginModal(true);
              }}
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscribeModal;
